import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import swal from 'sweetalert';
import { withNamespaces } from 'react-i18next';
import { Editor } from 'primereact/editor';

const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

class EmailSettingComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isEdit: false,
            selectedValue: '',
            emailSettingData: { 
                EmailSubject: '',
                EmailBody: ''
            }
        }
    }
    componentDidUpdate(prevProps) {
        console.log("props", this.props.getAllEmailSettingData)
        if (prevProps.getAllEmailSettingData != this.props.getAllEmailSettingData) {
            if (this.state.selectedValue == "") {
                this.setState({
                    selectedValue: document.getElementsByName('EmailCategory')[0].value
                })
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        const { t } = this.props;
        console.log("next", nextProps);
        if (nextProps.getAllEmailSettingData.updatedEmailSetting != this.props.getAllEmailSettingData.updatedEmailSetting) {
            if (nextProps.getAllEmailSettingData.statusCode == 200) {
                swal(`${t('Email Setting.Email setting updated')}`, {
                    icon: "success",
                });
                this.props.allEmailSetting();
            }
        }
    }
    handleChange = (event) => {
        this.setState({ selectedValue: event.target.value })
    }
    handleInput = (e) => {
        // console.log(e)
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            emailSettingData:
                { ...prevState.emailSettingData, 
                    EmailSubject : value ,
                      }
        }))
        sleep(2000).then(() => {
            console.log("setstate", this.state);
        })
    }
    handleInput1 = (e) => {
        // console.log(e)
        // let value = e.target.value;
        // let name = e.target.name;
        this.setState(prevState => ({
            emailSettingData:
                { ...prevState.emailSettingData,   
                    EmailBody : e.htmlValue  }
        }))
        sleep(2000).then(() => {
            console.log("setstate", this.state);
        })
    }
    openModal = (value) => {
        console.log("value", value);
        this.setState({
            isEdit: true,
            emailSettingData: {
                EmailSubject: value.EmailSubject,
                EmailBody: value.EmailBody
            }
        })
    }
    closeModal = () => {
        this.setState({ isEdit: false })
    }
    update = () => {
        const { t } = this.props;
        if (this.state.emailSettingData.EmailSubject.length > 0 && this.state.emailSettingData.EmailBody.length > 0) {
            if (this.state.selectedValue == "ApplicationRejection") {
                this.props.updateRejection(this.state.emailSettingData.EmailSubject, this.state.emailSettingData.EmailBody);
            }
            else if (this.state.selectedValue == "ApprovalTime") {
                this.props.updateApproval(this.state.emailSettingData.EmailSubject, this.state.emailSettingData.EmailBody);
            }
            else if (this.state.selectedValue == "OneTimePassword") {
                this.props.updateForgotPswd(this.state.emailSettingData.EmailSubject, this.state.emailSettingData.EmailBody);
            }
            else if (this.state.selectedValue == "RegistrationTime") {
                this.props.updateRegistration(this.state.emailSettingData.EmailSubject, this.state.emailSettingData.EmailBody);
            }
            else if (this.state.selectedValue == "Support") {
                this.props.updateSupportEmail(this.state.emailSettingData.EmailSubject, this.state.emailSettingData.EmailBody);
            }
            else if (this.state.selectedValue == "Acknowledge") {
                this.props.updateAcknowledgeEmail(this.state.emailSettingData.EmailSubject, this.state.emailSettingData.EmailBody);
            }
            this.setState({ isEdit: false })
        }
        else {
            swal(`${t('Email Setting.Please enter subject and body')}`);
        }
    }
    render() {
        const { t } = this.props;
        let emailCategoryArr = this.props.getAllEmailSettingData.emailSettingList;
        let emailCategoryOptions = emailCategoryArr.map((data, index) =>
            <option
                key={index}
                value={data.EmailCategory}
            >
                {data.DisplayName}
            </option>
        );
        let emailData = emailCategoryArr.filter(
            m => (m.EmailCategory == this.state.selectedValue))[0]

        return (
            <div className="container">
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Email Setting.Email Setting')}</h2>
                </div>
                <div className="panel panel-widget forms-panel w3-last-form setting-layout">
                    <div className="setting-data">
                        <div className="row">
                            <div className="col-md-6">
                                <select name="EmailCategory" className="custom-search-select" onChange={this.handleChange}>
                                    {emailCategoryOptions}
                                </select>
                            </div>
                            {  emailData !== undefined ? 
                                <div className="col-md-6 text-right m-b-15">
                                         <button type="button" className="btn btn-primary"
                                            onClick={this.openModal.bind(this, emailData)}>{t('Alarm Setting.Edit')}</button>
                                    </div> : ''
                            }
                        </div>
                        {
                            emailData !== undefined ?
                                <div className="row">
                                
                                    <div className="col-md-12">
                                        {this.state.selectedValue == 'Support' ? '' : 
                                        <p className="email-sub-main">
                                            <span className="email-sub"> {t('Email Setting.Subject')} :</span>
                                            <p dangerouslySetInnerHTML={{ __html: emailData.EmailSubject }}></p>
                                        </p>
                                        }
                                        <p className="email-body-main">
                                            <span className="email-sub"></span>
                                            <p dangerouslySetInnerHTML={{ __html: emailData.EmailBody }}></p>
                                        </p>
                                    </div>

                                </div> : ''}

                    </div>
                </div>
                <Modal open={this.state.isEdit} onClose={this.closeModal} center classNames={{modal: "customModal"}}>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2 style={{fontWeight: 600, color: '#000000'}}>{t('Email Setting.Edit Email Setting')}</h2>
                        </div>
                        <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                    <form className="form-horizontal modalForm">
                                        {this.state.selectedValue == 'Support' ? '' : 
                                        <div className="form-group">
                                            <label style={{color : '#000000'}} className="col-sm-3 control-label">{t('Email Setting.Subject')}</label>
                                            <div className="col-sm-9">
                                                <textarea
                                                    rows="3"
                                                    id="EmailSubject"
                                                    name={'EmailSubject'}
                                                    value={this.state.emailSettingData.EmailSubject}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                ></textarea>
                                                {/* <Editor style={{height:'150px'}} 
                                                    value={this.state.emailSettingData.EmailSubject} 
                                                    onTextChange={(e) => this.handleInput(e)}
                                                /> */}
                                            </div>
                                        </div> }
                                        <div className="form-group">
                                            <label style={{color : '#000000'}} className="col-sm-3 control-label">{t('Email Setting.Body')}</label>
                                            <div className="col-sm-9">
                                                {/* <textarea
                                                    rows="10"
                                                    id="EmailBody"
                                                    name={'EmailBody'}
                                                    value={this.state.emailSettingData.EmailBody}
                                                    className="form-control1 email-body"
                                                    onChange={this.handleInput}
                                                ></textarea> */}
                                                <Editor style={{height:'200px'}} className="editor-email"
                                                    value={this.state.emailSettingData.EmailBody} 
                                                    onTextChange={(e) => this.handleInput1(e)}  />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-sm-offset-5 col-sm-6">
                                                <p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary general-btn"
                                                        onClick={this.update}
                                                    >
                                                        {t('Alarm Setting.Save')}
                                            </button>
                                                </p>
                                            </div>
                                        </div>
                                    </form></div></div></div></div>
                </Modal>
            </div>
        )
    }
}

export default withNamespaces()(EmailSettingComponent);